import { queryOptions, useQuery } from '@tanstack/react-query'
import { QUERY_TIME_CONFIG } from '@omnea-app/fe-api-client/queryConfig'
import { supplierPortalPath } from '@omnea-app/fe-api-client/supplierPortalPath'
import { useAuthenticatedUser, useIsSupplierRole } from '@omnea-app/fe-auth/UserSessionProvider'
import { UsersHttpClient } from '@omnea-app/users/usersHttpClient'
import { listGroupsQueryKey } from './groupsQueryKeys'

export const listGroupsQueryOptions = (getToken: () => Promise<string>, isSupplier = false) =>
  queryOptions({
    queryKey: [listGroupsQueryKey],
    queryFn: async () => {
      const token = await getToken()
      const apiClient = new UsersHttpClient({ omneaJwt: token })
      const { data } = await apiClient.GET(supplierPortalPath('/groups/list', isSupplier))
      return data
    },
  })

export const useListGroups = () => {
  const { getToken } = useAuthenticatedUser()
  const isSupplier = useIsSupplierRole()
  // Set here rather than on the shared options, for the reason given in useViewableGroupIds:
  // a mutation reads the options' key back, and a stale write would revert a rename.
  return useQuery({ ...listGroupsQueryOptions(getToken, isSupplier), staleTime: QUERY_TIME_CONFIG.REFERENCE_DATA_STALE_TIME })
}
